// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const listWorkflowsQuery: any = graphql(`
  query ListWorkflows(
    $contentId: IDQueryOperatorArgs
    $includeTotalCount: Boolean
    $name: StringQueryOperatorArgs
    $ordering: [OrderBy!]
    $page: Int
    $pageSize: Int
    $pointInTime: BooleanQueryOperatorArgs
    $userId: IDQueryOperatorArgs
  ) {
    listWorkflows(
      contentId: $contentId
      includeTotalCount: $includeTotalCount
      name: $name
      ordering: $ordering
      page: $page
      pageSize: $pageSize
      pointInTime: $pointInTime
      userId: $userId
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        totalCount
        startCursor
        endCursor
      }
      edges {
        node {
          id
          createdAt
          resultCount
          resultGroupCount
          percentComplete
          enabled
          user {
            fullName
            id
          }
          settings {
            responses {
              content {
                id
                contentType
                title
              }
            }
            type
            name
            dueFromHired
          }
        }
      }
    }
  }
`);
